export { default } from './modules/JavascriptTimeAgo'

export {
	intlDateTimeFormatSupported as intlDateTimeFormatSupported,
	intlDateTimeFormatSupportedLocale as intlDateTimeFormatSupportedLocale
} from './modules/locale'


//////////////////
// WEBPACK FOOTER
// ./node_modules/javascript-time-ago/index.js
// module id = 584
// module chunks = 0